import React, { ChangeEvent, useState } from 'react';
import styled from 'styled-components';

export interface InputProps {
  /** id(input의 id)*/
  id?: string;
  /** name(input의 name)*/
  name?: string;
  /** type(input의 type)*/
  type?: string;
  /** value(input의 value)*/
  value?: string | number;
  /** 초기값이 있을 경우 value 대신 입력*/
  defaultValue?: string | number;
  /** 너비(string은 입력)*/
  width?: string | number;
  /** 높이*/
  height?: number;
  /** 입력값이 에러인지 구분하는 boolean값*/
  $isError?: boolean;
  /** 입력하는 폰트 크기*/
  fontSize?: number;
  /** 별도 스타일 지정시 css 입력 */
  style?: React.CSSProperties;
  /** 비활성화 여부 */
  disabled?: boolean;
  /** 값이 없을 때 보여줄 예시 텍스트*/
  placeholder?: string;
  /** 단위. 입력시 입력한 값을 input 끝에 보여줌*/
  unit?: string;
  /** 입력하는 영역 왼쪽에 아이콘 추가시 아이콘 경로 입력*/
  $leftIco?: any;
  /** 입력값이 변경될 때 이벤트*/
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** 키보드 입력시 이벤트*/
  onKeyDown?: any;
  /** 읽기 전용 여부*/
  readOnly?: boolean;
  /** 특정 상황(유효성 성공/실패)에 따른 메세지 문자열*/
  message?: string;
  /** type='number' 일 때 최소값*/
  min?: number | string;
  /** type='number' 일 때 최대값*/
  max?: number | string;
}
export const InputStyle = {
  Wrap: styled.div<InputProps>`
    position: relative;
    display: flex;
    align-items: center;
    width: ${(p) => (p.width ? (typeof p.width === 'number' ? p.width + 'px' : p.width) : '16px')};
    height: ${(p) => (p.height ? p.height + 'px' : '52px')};
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid ${(p) => (p.$isError ? '#DA491D' : '#DBDFE5')};
    //overflow: hidden;
    &:focus-within {
      border-color: #0a95b4;
    }
    .leftIco {
      width: 24px;
      height: 24px;
      display: block;
      background: ${(p) => `url(${p.$leftIco}) no-repeat center`};
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%); /* 아이콘을 세로 중앙 정렬 */
    }
  `,
  Input: styled.input<InputProps>`
    /* flex: 1; */
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    color: #192640;
    border-radius: 4px;
    padding: ${(p) => (p.unit ? '0 30px 0 16px' : p.$leftIco ? '0 16px 0 54px' : '0 16px')};
    box-sizing: border-box;
    margin: 0;
    font-size: ${(p) => (p.fontSize ? p.fontSize + 'px' : '16px')};
    font-weight: 500;
    &::placeholder {
      color: #8d97a4;
    }
    &:disabled,
    &:read-only {
      background: #f1f1f5;
    }
    &::-webkit-inner-spin-button {
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }
  `,
  ToggleType: styled.button<{ $isPassword: boolean }>`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
  `,
  message: styled.p<{ $isError?: boolean }>`
    position: absolute;
    left: 8px;
    top: calc(100% + 8px);
    font-size: 12px;
    font-weight: 500;
    color: ${(p) => (p.$isError ? '#DC5700' : '#00B074')};
  `,
};

/**
 *
 * @param type
 * @param id
 * @param name
 * @param value
 * @param width
 * @param height
 * @param fontSize
 * @param $isError
 * @param disabled
 * @param style
 * @param onChange
 * @param placeholder
 * @param $leftIco
 * @param onKeyDown
 * @param defaultValue
 * @param readOnly
 * @param min
 * @param max
 * @param message
 * @constructor
 */
const Input = ({ type = 'text', id, name, value, width, height, fontSize, $isError, disabled, style, onChange, placeholder, $leftIco, onKeyDown, defaultValue, readOnly, min, max, message }: InputProps) => {
  const [$isPassword, setIsPassword] = useState(true);

  const onChangeWithType = (e) => {
    //  if (type === 'number') {
    //    const inputValue = e.target.value;
    //    // 숫자만 허용
    //    if (/^\d*$/.test(inputValue)) {
    //    } else {
    //      e.target.value = e.target.value.replace(/[^0-9]/g, ''); // 숫자만 허용
    //      return;
    //    }
    //  }
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <InputStyle.Wrap width={width} height={height} $isError={$isError} style={style} $leftIco={$leftIco}>
      {$leftIco && <span className="leftIco"></span>}
      <InputStyle.Input
        type={type === 'password' ? ($isPassword ? 'password' : 'text') : type}
        $leftIco={$leftIco}
        id={id}
        name={name}
        onChange={onChangeWithType}
        fontSize={fontSize}
        disabled={disabled}
        readOnly={readOnly}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        min={min}
        max={max}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onKeyDown && onKeyDown();
          }
        }}
      />
      {message && <InputStyle.message $isError={$isError}>{message}</InputStyle.message>}
    </InputStyle.Wrap>
  );
};

export default Input;
